import { render } from "./GeneralModal.vue?vue&type=template&id=e230b16c&scoped=true"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"

import "./GeneralModal.vue?vue&type=style&index=0&id=e230b16c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e230b16c"]])

export default __exports__